import { render, staticRenderFns } from "./QuestionRecord.vue?vue&type=template&id=1d43ec58&scoped=true&"
import script from "./QuestionRecord.vue?vue&type=script&lang=js&"
export * from "./QuestionRecord.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRecord.vue?vue&type=style&index=0&id=1d43ec58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43ec58",
  null
  
)

export default component.exports